export const GET_COURIERS = Symbol('GET_COURIERS');
export const GET_COURIERS_REQUEST = Symbol('GET_COURIERS_REQUEST');
export const GET_COURIERS_SUCCESS = Symbol('GET_COURIERS_SUCCESS');
export const GET_COURIERS_ERROR = Symbol('GET_COURIERS_ERROR');

